<template>
  <layout>
    <page-header :header="$t('vehicles.edit')" :actions="headerActions">
      <template #default="props">
        <span
          :class="{
            'btn-primary': rideType === props.action.rideType,
            'btn-default': rideType !== props.action.rideType,
          }"
          class="btn"
        >
          {{ props.action.text }}
        </span>
      </template>
    </page-header>
    <div class="content">
      <resource-form
        v-if="currentDivision"
        :id="$route.params.id"
        :ride-type="rideType"
        @saved="returnBack"
        @cancelled="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'vehicles'

export default {
  name: 'VehicleEdit',

  components: {
    ResourceForm,
  },

  data() {
    return {
      rideType: 'transfer',
      actions: [],
    }
  },
  computed: {
    headerActions() {
      return this.actions
    },
  },

  watch: {
    '$settings._loaded'(loaded) {
      if (loaded) {
        this.updateActions()
      }
    },
  },

  created() {
    if (this.$settings._loaded) {
      this.updateActions()
    }
  },

  methods: {
    updateActions() {
      if (this.$settings.one_price_ride_type) {
        this.rideType = 'city_taxi';
        this.actions = []
      } else {
        this.actions = [
          {
            text: this.$t('enums.ride_type.transfer'),
            onClick: this.onActionClick,
            rideType: 'transfer',
          },
          {
            text: this.$t('enums.ride_type.city_taxi'),
            onClick: this.onActionClick,
            rideType: 'city_taxi',
          },
          {
            text: this.$t('enums.ride_type.delivery'),
            onClick: this.onActionClick,
            rideType: 'delivery',
          },
        ]
      }
    },
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
    onActionClick(action) {
      this.rideType = action.rideType
    },
  },
}
</script>
